module.exports = __webpack_public_path__ + "static/img/icon-excel.a6baa527.png";